import React, { useEffect } from 'react';
import CircularProgress from 'material-ui/CircularProgress';

import styles from 'styles/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getCompanies } from 'actions/companies';
import { getRealCompanies } from 'actions/realCompanies';
import CompaniesRealNamesTable from './CompaniesRealNamesTable';

function CompanyRealName({getCompanies, getRealCompanies, isLoaded }) {

    useEffect(() => {
        getCompanies();
        getRealCompanies();
    }, []);
    
    return (
        <div className='table-page'>
            <CircularProgress
                className={!isLoaded ? '' : 'hidden'}
                style={styles.circularProgress}
            />

            <div className={isLoaded ? '' : 'hidden'}>
                <div className='container'>
                    <h2>real companies names</h2>
                    <CompaniesRealNamesTable />
                </div>
            </div>
        </div>
    );
}

export default connect(
    (state) => {
        return {
            isLoaded: state.companies.isLoaded,
        };
    },
    dispatch => bindActionCreators({
        getCompanies,
        getRealCompanies,
    },
    dispatch),
)(CompanyRealName);



// WEBPACK FOOTER //
// ./app/components/Companies/CompanyRealName/Page.jsx